export default __webpack_public_path__ + "media/images/about/awards-number.jpg";